<template>
  <div class="home base-pad">
    <div style="display: flex;justify-content: space-between;width: 60vw;align-items: center;">
      <div style="text-align: left;">
        
        <div style="font-size: 28px;font-weight: bold;color: rgba(24,24,24,1);">{{ zh_en=='zh'?'品牌故事':'Brand Stories' }}</div>
        <!-- <div style="font-size: 22px; color: #181818;">基于三百年吴门医药传承让当代大众活出真健康</div> -->
      </div>


      <div style="text-align: right;">
        <LookMore :linkUrl="'/culture'" />
      </div>
    </div>



    <div style="display: flex;justify-content: space-between;margin-top: 40px;width: 60vw;">


      <div style="width: 30%;">
        <div class="default" :class='activityIndex == index ? "activity" : ""' v-for="(item, index) in homelist"
          :key="index" @click="changeIndex(index)" style="display: flex;align-items: center;">
          <div class="defaultC" :class='activityIndex == index ? "activityC" : ""' style="margin-right: 16px;"></div>
          <div>{{ item.title }}</div>
        </div>


      </div>



      <div style="width: 70%;text-align: left;" v-html="content">

      </div>



    </div>
  </div>
</template>

<script>
import LookMore from '@/components/home/LookMore.vue'

// @ is an alias to /src
export default {
  props: {
    homelist: {
      default: []
    },
   
  },
  data() {
    return {
      one: true,
      activityIndex: 0,
      content: ' '
    }
  },
  components: {
    LookMore
  },
  mounted() {
  },
  methods: {
    changeIndex(e) {
      this.activityIndex = e
      this.content = this.homelist[e].content
      this.content.replace('nowrap','wrap')
    }
  }

}
</script>


<style lang="less" scoped>
.default {
  color: #7F7F7F;
  font-size: 16px;
  margin-bottom: 44px;
}

.activity {
  color: #8A2E26;
  font-size: 20px;
}

.defaultC {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  border: 1px #7F7F7F solid;
  background-color: #fff;
}

.activityC {
  width: 17px;
  height: 17px;
  border-radius: 50%;
  border: 1px solid #8A2E26;
}

.home {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url(../../static/images/homeBack.png);
  background-size: 100% 100%;
}

p,
span {
  width: 100% !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
}
</style>
